import { Box, FormControl, InputAdornment, TextField } from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React from 'react';

export const RefundFormSummary = ({
  refundAmount,
  refundPercentage,
  error,
  onRefundAmountChange,
  ticket,
}) => {
  const maxRefundAmount = ticket?.order?.price - ticket?.order?.amountRefunded;

  const handleRefundAmountChange = (e) => {
    let value = e.target.value; // Récupère la valeur en tant que chaîne de caractères

    // Supprimer les espaces et les zéros au début
    value = value.replace(/^0+/, '') || '0'; // Si la valeur est vide après suppression, mettre 0

    // Si la valeur n'est pas numérique, on réinitialise à 0
    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) {
      value = '0';
    } else {
      // Limiter la valeur à "maxRefundAmount"
      if (numericValue >= maxRefundAmount) value = maxRefundAmount.toString();
      if (numericValue < 0) value = '0';
    }

    // On met à jour le state avec la nouvelle valeur
    onRefundAmountChange(value);
  };

  const isError = Boolean(error); // Vérification si une erreur existe
  const helperText = error || ''; // Texte d'erreur à afficher

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '69% 29%',
          gap: 2,
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        {/* Montant de la remise */}
        <FormControl variant="standard" sx={{ width: '100%' }}>
          <TextField
            variant="outlined"
            label={`Montant de la remise - max : ${maxRefundAmount}`}
            size="small"
            value={refundAmount}
            type="number"
            onChange={handleRefundAmountChange}
            // Applique l'état d'erreur si nécessaire
            error={isError}
            helperText={helperText} // Affiche le texte d'erreur sous le champ
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    {getSymbolFromCurrency(
                      ticket?.contact?.store?.country?.currency?.code
                    )}
                  </InputAdornment>
                ),
              },
            }}
          />
        </FormControl>

        {/* Affichage du pourcentage actuel et du pourcentage déjà remboursé */}
        <FormControl variant="standard" sx={{ width: '100%' }}>
          <TextField
            variant="outlined"
            label="% Actuel | % Déjà demandé"
            size="small"
            disabled
            value={
              (refundPercentage
                ? `${refundPercentage.toFixed(3)}%`
                : '0.000%') +
              ` | ${(
                (ticket?.order?.amountRefunded / ticket?.order?.price) *
                100
              ).toFixed(3)}%`
            }
          />
        </FormControl>
      </Box>
    </Box>
  );
};
